import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { NAV } from "../config-layout";
import { useNavData } from "./config-navigation";
import NavToggleButton from "../common/nav-toggle-button";
import Logo from "../../modules/auth/pages/Logo";
import { hideScroll } from "../../theme/css";
import { NavSectionMini } from "../../components/layout-components/nav-section";
import Searchbar from "../common/searchbar";

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = {
    user: {
      role: "admin",
    },
  };

  const navData = useNavData();

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: "fixed",
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: "auto", my: 2 }} />

        <Stack m={2} justifyContent="center" alignItems="flex-start">
          {" "}
          <Searchbar />
        </Stack>
        <NavSectionMini
          data={navData}
          slotProps={{
            currentRole: user?.role,
          }}
        />
      </Stack>
    </Box>
  );
}
